import {Injectable} from '@angular/core';

@Injectable()
export class SecurityService {
    id:string;
    userId: string;
    authentication: string;
    pid: string;
    errorMessage: string;
    BookingType: string;
    IsAdminUser: boolean;
    RoleId: number;
}


// WEBPACK FOOTER //
// node_modules/angular2-template-loader!./app/security/security.service.ts